// Gatsby-compatible cookie utility for generating and persisting a device id.

function getCookie(name) {
  if (typeof document === "undefined") return null;
  const match = document.cookie
    .split("; ")
    .map((v) => v.split("="))
    .find(([k]) => k === name);
  return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name, value, opts = {}) {
  if (typeof document === "undefined") return;
  const parts = [
    `${name}=${encodeURIComponent(value)}`,
    `Path=${opts.path || "/"}`,
    `Max-Age=${opts.maxAge || 60 * 60 * 24 * 365}`,
  ];
  if (opts.secure) parts.push("Secure");
  if (opts.sameSite) parts.push(`SameSite=${opts.sameSite}`);
  document.cookie = parts.join("; ");
}

function generateId() {
  try {
    // Browser
    if (
      typeof crypto !== "undefined" &&
      typeof crypto.randomUUID === "function"
    ) {
      return crypto.randomUUID();
    }
    // Node.js 16+/18+
    // eslint-disable-next-line no-undef
    if (typeof require === "function") {
      // Avoid hard dependency; only attempt if available
      try {
        // eslint-disable-next-line global-require
        const nodeCrypto = require("crypto");
        if (typeof nodeCrypto.randomUUID === "function")
          return nodeCrypto.randomUUID();
      } catch (_) {}
    }
  } catch (_) {}
  // Fallback
  return `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random()
    .toString(36)
    .slice(2)}`;
}

export function getAppDeviceId(formName) {
  // During SSR, there's no document; defer to client
  if (typeof document === "undefined") return null;
  let appDeviceId = getCookie(formName);
  if (!appDeviceId) {
    appDeviceId = generateId();
    setCookie(formName, appDeviceId, {
      path: "/",
      maxAge: 60 * 60 * 24 * 365,
      secure: process.env.NODE_ENV === "production",
      sameSite: "Lax",
    });
  }
  return appDeviceId;
}

// Read existing id without creating; returns null if missing
export function readAppDeviceId(formName) {
  if (typeof document === "undefined") return null;
  return getCookie(formName);
}

export function deleteAppDeviceId(formName) {
  if (typeof document === "undefined") return;
  // Delete cookie by setting Max-Age=0
  document.cookie = `${formName}=; Max-Age=0; Path=/`;
}
